<template>
  <div>
    <naj-box :title="local.caseRelatedRequest.interpretationJudgementRequest.title">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.selectbox"
            :value.sync="formModel.judgementCode"
            :label="local.caseRelatedRequest.interpretationJudgementRequest.judgementCode"
            :items="judgments"
            item-value="judgementCode"
            item-text="judgementCode"
            validates="required"
            :disabled="isViewMode || isEditMode"
            @change="setSelectedJudgment"
          >
          </naj-input>
        </v-col>
      </v-row>
    </naj-box>
    <naj-confirmation
      :show-modal="judgementInterpretationTextModal"
      :max-width="1000"
      :no-header="true"
      :is-persistent="true"
      :ok-btn-label="local.caseRelatedRequest.interpretationJudgementRequest.accept"
      :close-btn-label="local.caseRelatedRequest.interpretationJudgementRequest.cancel"
      @cancel="closeJudgementInterpretationTextModal"
      @ok="addRequestSubject"
    >
      <template slot="message-content">
        <v-row>
          <v-col>
            <span>
              {{ local.caseRelatedRequest.interpretationJudgementRequest.addJudgementTextForInterpretationBtn }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <naj-input
              :type-id="formFieldType.selectbox"
              :label="local.caseRelatedRequest.interpretationJudgementRequest.judgementSectionLabel"
              :items="judgementCorrectionSections"
              :value.sync="subjectDetails.judgementCategory"
              item-text="name"
              item-value="id"
              :disabled="isViewMode"
              validates="required"
              @change="getJudgementSection"
            ></naj-input>
          </v-col>
        </v-row>
        <v-row v-if="subjectDetails.judgementSectionText && !loading">
          <v-col>
            <span>
              {{ local.caseRelatedRequest.interpretationJudgementRequest.judgementSectionText }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              v-if="loading"
              class="loader-holder"
            >
              <naj-loader></naj-loader>
            </div>
            <div
              v-if="judgementSectionText && !loading"
              class="scrollable-div"
            >
              <p
                ref="content"
                @mouseup="highlightSelectedText"
                v-html="judgementSectionText"
              />
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="judgementSectionText && !loading"
          class="note-container"
        >
          <v-col>
            <span class="sub-note">
              {{ local.caseRelatedRequest.interpretationJudgementRequest.highlightNote }}
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <naj-input
              :type-id="formFieldType.textarea"
              :label="local.caseRelatedRequest.interpretationJudgementRequest.theInterpretationText"
              :value.sync="subjectDetails.userAddedText"
              rows="5"
              validates="required|max:2800|allowed_special_character"
            ></naj-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <span>
              {{ local.caseRelatedRequest.interpretationJudgementRequest.attachment }}
            </span>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            v-if="subjectFile && subjectFile.length != 0"
            cols="3"
          >
            <attachment-card
              :file="{ ...uploadedFile }"
              :show-delete-button="!isViewMode"
              @deleteAttachment="showDeleteSubjectModal"
              @viewAttachment="viewAttachment"
            ></attachment-card>
          </v-col>
          <v-col
            v-else
            class="subject-attachment"
            cols="12"
          >
            <load-local-attachment
              :max-file-size="5"
              :upload-disabled="isViewMode"
              @fileSelected="fileSelected"
            >
            </load-local-attachment>
          </v-col>
        </v-row>
        <render-attachment-modal
          :attachment-file="uploadedFile"
          :modal-visibility="showViewAttachmentModal"
          @modalClose="hideViewAttachmentModal"
        >
        </render-attachment-modal>

        <naj-confirmation
          :show-modal="showDeleteSubjectAttachment"
          color="error"
          :title="local.common.removeConfirmation"
          :message="local.caseRelatedRequest.interpretationJudgementRequest.removeAttachment"
          :ok-btn-label="local.common.remove"
          @ok="confirmDeleteSubjectFile"
          @cancel="cancelDeleteSubjectFile"
        >
        </naj-confirmation>
      </template>
    </naj-confirmation>

    <naj-box :title="local.caseRelatedRequest.interpretationJudgementRequest.editJudgementText">
      <div
        v-for="(requestSubject,index) in formModel.requestSubjects"
        :key="index"
      >
        <v-row>
          <v-col cols="10">
            <label class="section-title">{{ requestSubject.judgementSectionName }}</label>
          </v-col>
          <v-col cols="2">
            <v-btn
              v-if="!isViewMode"
              icon
              @click="editSubject(index)"
            >
              <v-icon color="primary">
                mdi-lead-pencil
              </v-icon>
            </v-btn>
            <v-btn
              v-if="!isViewMode"
              icon
              @click="selectSubjectToDelete(index) "
            >
              <v-icon color="red">
                mdi-delete
              </v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            v-if="requestSubject.judgementHighlightedText"
            cols="6"
          >
            <naj-input
              disabled
              :type-id="formFieldType.textarea"
              :label="local.caseRelatedRequest.interpretationJudgementRequest.judgementSectionText"
              :value.sync="requestSubject.judgementHighlightedText"
              validates="required|max:2800|allowed_special_character"
              rows="5"
            ></naj-input>
          </v-col>
          <v-col cols="6">
            <label class="d-flex attachment-name"> {{ local.attachments.attachment }}</label>

            <div
              v-if="requestSubject.subjectFile && requestSubject.subjectFile.sharePointId && requestSubject.subjectFile.fileName"
              class="d-flex attachment-name"
            >
              {{ requestSubject.subjectFile.fileName }}
              <v-btn
                icon
                class="download-attachment"
                @click="handleViewAttachment(requestSubject.subjectFile)"
              >
                <v-icon>
                  mdi-eye
                </v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <naj-input
              disabled
              :type-id="formFieldType.textarea"
              :label="local.caseRelatedRequest.interpretationJudgementRequest.theInterpretationText"
              :value.sync="requestSubject.userAddedText"
              validates="required|max:2800|allowed_special_character"
              rows="5"
            ></naj-input>
          </v-col>
        </v-row>
      </div>
      <v-row v-if="!isViewMode">
        <v-col cols="9">
          <span>
            {{ local.caseRelatedRequest.interpretationJudgementRequest.addJudgementTextForInterpretation }}
          </span>
        </v-col>
        <v-col cols="3">
          <naj-button
            :disabled="formModel.requestSubjects && formModel.requestSubjects.length >= 5"
            @click="showJudgementInterpretationTextModal()"
          >
            {{ local.caseRelatedRequest.interpretationJudgementRequest.addJudgementTextForInterpretationBtn }}
          </naj-button>
        </v-col>
      </v-row>
    </naj-box>
    <naj-confirmation
      :show-modal="showDeleteSubjectConfirmationModal"
      :title="local.caseRelatedRequest.interpretationJudgementRequest.accept"
      :message="local.caseRelatedRequest.interpretationJudgementRequest.warningTextDelete"
      :ok-btn-label="local.common.yes"
      :close-btn-label="local.common.no"
      @ok="() => {
        showDeleteSubjectConfirmationModal = false;
        removeSubject();
      }"
      @cancel="showDeleteSubjectConfirmationModal = false"
    ></naj-confirmation>
  </div>
</template>

<script>
import { mode, socialIdentityTypeEnum, countriesEnum, judgementSection } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
import LoadLocalAttachment from '../../../../../components/shared/attachment-modal/load-local-attachment';
import AttachmentCard from '@/components/shared/attachment-modal/attachment-card';
import RenderAttachmentModal from '@/components/shared/attachment-modal/render-attachment-modal.vue';
const { mapState: mapLUTState } = createNamespacedHelpers('LookupsModule');
const { mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapState, mapActions, mapGetters } = createNamespacedHelpers('LawsuitModule');
const { mapActions: mapCasesActions } = createNamespacedHelpers('CasesModule');

const initSubjectDetails = () => ({
  selectedFile: {},
  judgementCategory: Object,
  userAddedText: '',
  subjectIndex: Object,
  judgementHighlightedText: null,
});
export default {
  name: 'InterpretationJudgmentRequest',
  inject: ['$validator'],
  components: {
    LoadLocalAttachment,
    AttachmentCard,
    RenderAttachmentModal,
  },
  props: {
    formModel: {
      type: Object,
      default: () => ({ requestSubjects: [] }),
    },
    requiredData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      judgments: [],
      selectedJudgment: {},
      judgementInterpretationTextModal: false,
      showDeleteSubjectAttachment: false,
      showViewAttachmentModal: false,
      subjectDetails: initSubjectDetails(),
      activeJudgement: '',
      subjectFile: [],
      showDeleteSubjectConfirmationModal: false,
      selectedSubject: 0,
      editedSubject: -1,
      judgementSectionTextResult: null,
      startIndex: 0,
      endIndex: 0,
      judgementSectionText: '',
      judgementSectionTexts: [],
    };
  },
  computed: {
    ...mapLUTState(['judgementCorrectionSections']),
    ...mapGlobalState(['userInfo']),
    isViewMode() {
      return this.formModel && this.formModel.mode === mode.view;
    },
    isEditMode() {
      return this.formModel && this.formModel.mode === mode.update;
    },
    isNewMode() {
      return this.$route.params.requestObjectKey === 'new';
    },
    uploadedFile() {
      if (this.subjectFile && this.subjectFile.length != 0 && this.subjectFile[0].attachmentKey !== undefined) {
        return {
          name: this.subjectFile[0].fileName,
          attachmentKey: this.subjectFile[0].attachmentKey,
          sharePointId: this.subjectFile[0].attachement,
          isImage: this.subjectFile[0].fileType.startsWith('image'),
          fileType: this.subjectFile[0].fileType,
        };
      }
      return {};
    },
  },
  watch: {},
  mounted() {
    if (this.formModel && this.formModel.judgementCode) {
      this.setSelectedJudgment();
    }

    this.$set(this.formModel, 'FixType', this.formModel.FixType ? this.formModel.FixType : {
      Text: '',
      Value: '',
    });

    if (this.formModel.FixType && this.formModel.FixType.Value) {
      this.formModel.FixType.Value = parseInt(this.formModel.FixType.Value);
    }

    this.readCurrentUserInfo();
    this.loading = true;
    const params = {
      isPega: this.formModel.isPega,
      objectKey: this.formModel.case.objectKey,
    };
    this.subjectDetails = initSubjectDetails();
    this.subjectFile = [];
    this.getCaseJudgments(params)
      .then((res) => {
        this.judgments = res.data;
        this.setSelectedJudgment();
      })
      .finally(() => (this.loading = false));
  },
  created() {
  },
  methods: {
    ...mapActions([
      'getJudgementSections',
    ]),

    ...mapCasesActions([
      'getCaseJudgments',
      'uploadAttachment',
    ]),
    handleViewAttachment(file) {
      this.$set(this, 'selectedFile', {
        name: file.fileName,
        isImage: file.fileType.startsWith('image'),
        sharePointId: file.sharePointId,
      });
      this.showViewAttachmentModal = true;
    },
    getJudgementSection(value) {
      if (this.judgementSectionTextResult && this.judgementSectionTextResult.judgementCode == this.selectedJudgment.judgementCode) {
        if (this.subjectDetails.judgementCategory == judgementSection.waqae)
          this.judgementSectionText = this.judgementSectionTextResult.waqae;
        else if (this.subjectDetails.judgementCategory == judgementSection.reasons)
          this.judgementSectionText = this.judgementSectionTextResult.reasons;
        else if (this.subjectDetails.judgementCategory == judgementSection.mantoq)
          this.judgementSectionText = this.judgementSectionTextResult.mantoq;
      }
      else {
        this.loading = true;
        const params = {
          judgementCode: this.selectedJudgment.judgementCode,
          caseCode: this.formModel.case.caseCode,
        };
        this.getJudgementSections(params)
          .then((res) => {

            this.judgementSectionTextResult = res;
            this.$set(this.judgementSectionTextResult, 'judgementCode', this.selectedJudgment.judgementCode);
            this.getJudgementSection();
          })
          .finally(
            () => (this.loading = false
            )
          );
      }
    },
    showDeleteSubjectModal() {
      this.showDeleteSubjectAttachment = true;
    },
    viewAttachment() {
      this.showViewAttachmentModal = true;
    },
    hideViewAttachmentModal() {
      this.showViewAttachmentModal = false;
    },
    removeSubject() {
      this.formModel.requestSubjects.splice(this.selectedSubject, 1);
    },

    editSubject(index) {
      this.editedSubject = index;
      this.subjectDetails = initSubjectDetails();
      this.subjectDetails.judgementCategory = this.formModel.requestSubjects[index].judgementSectionId;
      this.subjectDetails.judgementHighlightedText = this.formModel.requestSubjects[index].judgementHighlightedText;
      this.subjectDetails.userAddedText = this.formModel.requestSubjects[index].userAddedText;
      this.subjectDetails.judgementSectionText = this.judgementSectionTexts[index];
      this.startIndex = this.formModel.requestSubjects[index].startIndex;
      this.endIndex = this.formModel.requestSubjects[index].endIndex;

      this.$nextTick(() => {
        this.highlightByIndex(this.formModel.requestSubjects[index].startIndex, this.formModel.requestSubjects[index].endIndex);
      });
      this.subjectFile = [];
      if (this.formModel.requestSubjects[index].subjectFile !== undefined && this.formModel.requestSubjects[index].subjectFile.attachmentKey !== undefined) {
        this.subjectFile.push(this.formModel.requestSubjects[index].subjectFile);
      }
      this.judgementInterpretationTextModal = true;
    },
    confirmDeleteSubjectFile() {
      this.$delete(this.subjectFile, 0);
      this.cancelDeleteSubjectFile();
    },
    selectSubjectToDelete(index) {
      this.selectedSubject = index;
      this.showDeleteSubjectConfirmationModal = true;
    },
    cancelDeleteSubjectFile() {
      this.showDeleteSubjectAttachment = false;
    },
    fileSelected({ selectedAttachment: attachment, selectedAttachmentKey }) {
      this.loading = true;
      const reader = new FileReader();
      reader.onloadend = () => {
        var b64 = reader.result.replace(/^data:.+;base64,/, '');

        this.uploadAttachment({
          classification: 0,
          documentMetadata: {
            caseId: 0,
            caseCode: 0,
            requestId: 0,
            category: attachment.category,
            fileCategory: attachment.category,
          },
          fileCategory: attachment.category,
          extension: attachment.extension,
          base64FileContent: b64,
        })
          .then(({ data }) => {
            this.$set(this, 'subjectFile', [
              {
                attachement: data,
                fileName: attachment.name,
                fileType: attachment.fileObject.type,
                sharePointId: data,
                extension: attachment.extension,
                //  fileCategory: attachment.category,
                attachmentKey: selectedAttachmentKey,

              },
            ]);
          })
          .catch(err => this.toaster.error(err.message))
          .finally(() => (this.loading = false));
      };
      reader.readAsDataURL(attachment.fileObject);
    },
    setSelectedJudgment() {
      this.formModel.judgementCode && this.$set(this, 'selectedJudgment', (this.judgments || []).find(a => a.judgementCode == this.formModel.judgementCode) || {});
      if (this.formModel.judgementCode !== this.activeJudgement && !this.isViewMode) {
        this.formModel.requestSubjects = [];
        this.requestSubjects = [];
      }
      this.activeJudgement = this.formModel.judgementCode;
    },
    showJudgementInterpretationTextModal() {
      this.editedSubject = -1;
      this.subjectDetails = initSubjectDetails();
      this.subjectFile = [];
      this.judgementSectionText = '';

      if (this.selectedJudgment.judgementCode === undefined) {
        this.toaster.error(this.local.caseRelatedRequest.interpretationJudgementRequest.selectJudgementErrorMsg);
      }
      else {
        document.body.style.userSelect = 'none';
        this.judgementInterpretationTextModal = true;
      }
    },
    closeJudgementInterpretationTextModal() {
      document.body.style.userSelect = '';
      this.judgementInterpretationTextModal = false;
    },
    highlightSelectedText() {
      const selection = window.getSelection();
      const selectedText = selection.toString();
      if (!this.normalizeArabic(this.judgementSectionText).includes(this.normalizeArabic(selectedText))) {
        this.clearHighlights();
        this.toaster.error(this.local.caseRelatedRequest.interpretationJudgementRequest.selectValidTextErrorMsg);
        return;
      }

      // ensure some text is selected
      if (!selectedText) return;
      const content = this.$refs.content;
      // find the start and end positions
      let startOffset = 0;
      let endOffset = 0;
      let charCount = 0;

      const range = selection.getRangeAt(0);
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );
      // traverse text nodes to find exact start and end indices
      while (walker.nextNode()) {
        const node = walker.currentNode;
        // if the range starts in this node
        if (node === range.startContainer) {
          startOffset = charCount + range.startOffset;
        }
        // if the range ends in this node
        if (node === range.endContainer) {
          endOffset = charCount + range.endOffset;
          break;
        }
        charCount += node.textContent.length;
      }
      this.startIndex = startOffset;
      this.endIndex = endOffset;
      this.subjectDetails.judgementHighlightedText = selectedText;
      // highlight the text using the range API
      this.applyHighlight(range);
      // clear the selection
      selection.removeAllRanges();
    },
    highlightByIndex(startIndex, endIndex) {
      this.clearHighlightsOfEdit();
      const content = this.$refs.content;
      const text = content.textContent;

      // validate indices
      if (
        startIndex < 0 ||
        endIndex > text.length ||
        startIndex >= endIndex
      ) {
        alert('Invalid indices. Please enter valid start and end indices.');
        return;
      }

      // clear previous highlights
      this.clearHighlightsOfEdit();

      // create a Range object
      const range = document.createRange();

      let charCount = 0;
      let startNode = null;
      let endNode = null;
      let startOffset = 0;
      let endOffset = 0;

      // find the correct nodes and offsets for the indices
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      while (walker.nextNode()) {
        const node = walker.currentNode;
        const nodeLength = node.textContent.length;

        // determine start node and offset
        if (!startNode && charCount + nodeLength >= startIndex) {
          startNode = node;
          startOffset = startIndex - charCount;
        }

        // determine end node and offset
        if (!endNode && charCount + nodeLength >= endIndex) {
          endNode = node;
          endOffset = endIndex - charCount;
          break;
        }

        charCount += nodeLength;
      }

      // set the range to highlight the text
      if (startNode && endNode) {
        range.setStart(startNode, startOffset);
        range.setEnd(endNode, endOffset);

        // wrap the range in a <span> for highlighting
        const span = document.createElement('span');
        span.style.backgroundColor = 'cyan';
        range.surroundContents(span);
      }
    },

    clearHighlightsOfEdit() {
      const content = this.$refs.content;

      // remove all <span> elements but keep their text
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_ELEMENT,
        null,
        false
      );

      const spans = [];
      while (walker.nextNode()) {
        if (walker.currentNode.tagName === 'SPAN') {
          spans.push(walker.currentNode);
        }
      }

      spans.forEach((span) => {
        const parent = span.parentNode;
        while (span.firstChild) {
          parent.insertBefore(span.firstChild, span);
        }
        parent.removeChild(span);
      });
    },

    applyHighlight(range) {
      // clear previous highlights
      this.clearHighlights();
      // wrap the selected text in a span with a yellow background
      const highlightSpan = document.createElement('span');
      highlightSpan.style.backgroundColor = 'cyan';
      highlightSpan.textContent = range.toString();
      range.deleteContents(); // remove selected text
      range.insertNode(highlightSpan); // insert highlighted text
    },

    clearHighlights() {
      const content = this.$refs.content;

      // traverse and replace all spans with their plain text content
      const walker = document.createTreeWalker(
        content,
        NodeFilter.SHOW_ELEMENT,
        null,
        false
      );

      const spans = [];
      while (walker.nextNode()) {
        if (walker.currentNode.tagName === 'SPAN') {
          spans.push(walker.currentNode);
        }
      }

      spans.forEach((span) => {
        const parent = span.parentNode;
        while (span.firstChild) {
          parent.insertBefore(span.firstChild, span);
        }
        parent.removeChild(span);
      });
    },

    addRequestSubject() {
      if (!this.judgementSectionText) {
        this.toaster.error(this.local.caseRelatedRequest.interpretationJudgementRequest.addJudgementSectionTextErrorMsg);
      }
      else if (!this.subjectDetails.judgementHighlightedText) {
        this.toaster.error(this.local.caseRelatedRequest.interpretationJudgementRequest.selectJudgementTextErrorMsg);
      }
      else if (!this.subjectDetails.userAddedText) {
        this.toaster.error(this.local.caseRelatedRequest.interpretationJudgementRequest.addJudgementInterpretationTextErrorMsg);
      }
      else {
        var modifiedSubject = {
          judgementSectionId: this.subjectDetails.judgementCategory,
          judgementSectionName: this.judgementCorrectionSections.find(e => e.id == this.subjectDetails.judgementCategory).name,
          judgementHighlightedText: this.subjectDetails.judgementHighlightedText,
          // judgementSectionText: this.judgementSectionText ,
          userAddedText: this.subjectDetails.userAddedText,
          startIndex: this.startIndex,
          endIndex: this.endIndex,
          subjectFile: this.subjectFile && this.subjectFile.length > 0 ? this.subjectFile[0] : {},
        };

        if (this.editedSubject > -1) {
          this.requestSubjects[this.editedSubject] = modifiedSubject;
          this.judgementSectionTexts[this.editedSubject] = this.judgementSectionText;

        }
        else {
          this.requestSubjects.push(modifiedSubject);
          this.judgementSectionTexts.push(this.judgementSectionText);
        }
        this.formModel.requestSubjects = this.requestSubjects;
        this.closeJudgementInterpretationTextModal();
      }
    },
    readCurrentUserInfo() {
      if (this.userInfo) {
        const socialTypeId = this.userInfo.socialIdType;
        this.$set(this.formModel, 'socialIdType', socialTypeId);
        this.$set(this.formModel, 'socialId', this.userInfo.socialId);
        this.$set(this.formModel, 'firstName', this.userInfo.firstName);
        this.$set(this.formModel, 'fatherName', this.userInfo.fatherName);
        this.$set(this.formModel, 'grandFatherName', this.userInfo.grandFatherName);
        this.$set(this.formModel, 'familyName', this.userInfo.familyName);
        this.$set(this.formModel, 'dateOfBirth', this.userInfo.dateOfBirth);
        this.$set(this.formModel, 'nationalityCountryId', socialTypeId === socialIdentityTypeEnum.nationalId ? countriesEnum.saudiArabia : this.userInfo.nationalityCountryId);
        this.$set(this.formModel, 'sex', this.userInfo.gender);
        this.$set(this.formModel, 'isRetrievedFromMoi', true);
        this.$set(this.formModel, 'fullName', this.userInfo.fullName);
      } else {
        this.$set(this.formModel, 'socialIdType', null);
        this.$set(this.formModel, 'socialId', null);
        this.$set(this.formModel, 'firstName', null);
        this.$set(this.formModel, 'fatherName', null);
        this.$set(this.formModel, 'grandFatherName', null);
        this.$set(this.formModel, 'familyName', null);
        this.$set(this.formModel, 'dateOfBirth', null);
        this.$set(this.formModel, 'nationalityCountryId', null);
        this.$set(this.formModel, 'sex', null);
        this.$set(this.formModel, 'isRetrievedFromMoi', false);
        this.$set(this.formModel, 'fullName', null);
      }
    },
    normalizeArabic(str) {
      return str
        // Remove diacritics
        .replace(/[\u064B-\u0652\u0670\u0640]/g, '')
        // Normalize different forms of Alef
        .replace(/[إأآا]/g, 'ا')
        // Normalize Teh Marbuta and Heh
        .replace(/ة/g, 'ه')
        // Normalize different forms of Yeh
        .replace(/ي/g, 'ى')
        // Remove extra spaces
        .replace(/\s+/g, ' ')
        .trim();
    },

  },
};
</script>

<style lang="scss" scoped>
.sub-note {
  font-size: 14px;
  color: var(--app-secondary-color);
}
.note-container {
  margin-top: -12px;
}
.judgement-deed {
  display: flex;
  align-items: center;
  justify-content: center;
}

span {
  font-size: 22px;
}

.section-title {
  font-size: 22px;
  color: var(--app-primary-color);
}
.attachment-name {
  font-size: 18px;
}
.download-attachment {
  margin-right: 10px;
}
p {
  user-select: text;
  display: block;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #e9e9e9;
  overflow: auto;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
}
.scrollable-div {
  overflow-y: scroll;
  max-height: 200px;
}
.subject-attachment {
  display: flex;

  .subject-confirm-text {
    margin-left: 10px;
  }

  .uplaod-attachments-button .img-actions {
    width: 100% !important;
  }
}
</style>
